import type {ReactElement} from 'react';
import {BottomBarItem} from '@Components/contextual-menu/components/bottom-bar-item/bottom-bar-item';
import type {MediaControlsItemProps} from '@Components/contextual-menu/components/media-controls-item';
import {ImageCropActions} from '@EmailMakerReact/components/image-crop-actions/image-crop-actions';
import {getEmailImageCropPresetItems} from '@EmailMakerReact/lib/email-maker-image-crop-presets-library';
import type {ImageCropStripProps} from './image-crop-strip.types';
import styles from './image-crop-strip.module.scss';

export function ImageCropStrip({editor, cropState}: ImageCropStripProps): ReactElement {
  return (
    <div className={styles.cropStrip}>
      <div className={styles.presetList} role="toolbar" aria-label={window.i18next.t('pmwjs_crop')}>
        {getEmailImageCropPresetItems(editor, cropState).map(renderPresetTile)}
      </div>
      <div className={styles.cropActions}>
        <ImageCropActions editor={editor} idPrefix="email-maker-crop-strip" />
      </div>
    </div>
  );
}

function renderPresetTile(preset: MediaControlsItemProps): ReactElement {
  return (
    <BottomBarItem
      key={preset.id}
      id={`email-maker-crop-preset-${preset.id}`}
      icon={preset.icon}
      text={preset.text ?? ''}
      textClasses={styles.presetLabel}
      isSelected={preset.isSelected}
      onClick={(): void => {
        preset.onClick?.(preset.id);
      }}
    />
  );
}
